import * as React from 'react';
import * as _ from 'lodash';
import * as presetPages from '../../../../constants/pricingPresets';
import { PARTS } from './../../../../schemas/accessRightsModel';
export default function () {
    function onClick1(props, AR, preset, presetIndex) {
        this.selectPreset(preset);
    }
    function repeatPreset2(props, AR, preset, presetIndex) {
        return [React.createElement('li', {
                'className': 'assign-popup-algorithm-list__item ' + (this.state.selected && this.state.selected.id == preset.id ? 'selected' : ''),
                'onClick': onClick1.bind(this, props, AR, preset, presetIndex),
                'key': '4091'
            }, React.createElement('span', {
                'style': { backgroundImage: 'url(' + preset.icon + ')' },
                'className': 'assign-popup-algorithm-list__item-image'
            }), React.createElement('span', { 'className': 'assign-popup-algorithm-list__item-title' }, preset.name))];
    }
    function onClick3(props, AR) {
        this.selectPreset();
    }
    function repeatP4(props, AR, p, pIndex) {
        return [React.createElement('li', {
                'className': 'assign-popup-algorithm-list__item',
                'key': '13211'
            })];
    }
    function scopePropsAR5() {
        var props = this.props;
        var AR = this.props.AR;
        return React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement('div', { 'className': 'assign-popup' }, React.createElement.apply(this, [
            'ul',
            { 'className': 'assign-popup-algorithm-list assign-popup-algorithm-list--large' },
            _.map(this.props.presets, repeatPreset2.bind(this, props, AR)),
            AR.e(PARTS.ASSIGN_PP_CREATE) ? React.createElement('li', {
                'className': 'assign-popup-algorithm-list__item ' + (!this.state.selected ? 'selected' : ''),
                'onClick': onClick3.bind(this, props, AR),
                'key': '892'
            }, React.createElement('span', {
                'style': { backgroundImage: 'url(\'../content/views/dashboard/images/AlgorithmNew.svg\')' },
                'className': 'assign-popup-algorithm-list__item-image'
            }), React.createElement('span', { 'className': 'assign-popup-algorithm-list__item-title' }, 'Add New Algorithm')) : null,
            _.map(this.getBlanks(), repeatP4.bind(this, props, AR))
        ])));
    }
    return scopePropsAR5.apply(this, []);
}